import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CreditCardTransactionInfo from './CreditCardTransactionInfo';
import useFetchCreditCardTransaction from '@/hooks/useApi/useFetchCreditCardTransaction';
import { useDataFetchIndicator } from '@/hooks';
import { useToast } from '@/providers/Toast.provider';

type CreditCardTransactionContainerProps = {
  TransactionID: string;
  isParent?: boolean;
  jwt: string;
  ELinxRequestID?: string;
};

const CreditCardTransactionContainer: FC<CreditCardTransactionContainerProps> = ({
  TransactionID,
  isParent = false,
  jwt,
  ELinxRequestID = '',
}) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const toast = useToast();

  const { t } = useTranslation('translations', {
    keyPrefix: 'Transaction.TransactionHistory.Details.CreditCardTransactionInfo',
  });

  const { fetching, creditCardTransaction, fetchCreditCardTransaction } = useFetchCreditCardTransaction();

  useEffect(() => {
    setDataFetchingInfo(fetching, '', 'fullScreen', fetching);
  }, [fetching]);

  useEffect(() => {
    (async () => {
      try {
        await fetchCreditCardTransaction(TransactionID, jwt);
      } catch {
        toast.neutral(t('fetchingError', { defaultValue: 'Failed to fetch transaction details' }));
      }
    })();
  }, [TransactionID, jwt]);

  return (
    <div>
      {creditCardTransaction && (
        <CreditCardTransactionInfo
          transaction={creditCardTransaction}
          isParent={isParent}
          jwt={jwt}
          ELinxRequestID={ELinxRequestID}
        />
      )}
    </div>
  );
};

export default CreditCardTransactionContainer;
